import type { CitationResponse } from '@/lib/api'
import { citationDisplayName, staleStatus } from '@/lib/citations'
import styles from './CitationList.module.css'

export type CitationListProps = {
  citations: readonly CitationResponse[]
}

export default function CitationList({ citations }: CitationListProps) {
  if (citations.length === 0) return null
  return (
    <details className={styles.wrap}>
      <summary className={styles.summary}>Kilder ({citations.length})</summary>
      <ol className={styles.list}>
        {citations.map((c) => (
          <li key={c.passageId || `${c.documentNumber}-${c.documentName}`}>
            <CitationRow citation={c} />
          </li>
        ))}
      </ol>
    </details>
  )
}

function CitationRow({ citation }: { citation: CitationResponse }) {
  const name = citationDisplayName(citation)
  const stale = staleStatus(citation)
  const link =
    citation.docUrl !== '' ? (
      <a href={citation.docUrl} target="_blank" rel="noreferrer noopener">
        {name}
      </a>
    ) : (
      <span>{name}</span>
    )
  return (
    <div className={styles.row}>
      <div>
        {citation.documentNumber}. {link}
      </div>
      {stale.stale ? <div className={styles.warning}>⚠ {stale.message}</div> : null}
    </div>
  )
}
